export const TEMPLATE_BLUE = '#128ff9'
export const PRIMARY_COLOR = '#16FFBD'
export const PRIMARY_COLOR_DARKER = '#439F76'
export const SECONDARY_COLOR = '#151f2a'
export const SECONDARY_COLOR_DARKER = '#F070A1'
